import React from "react";
import PropTypes from "prop-types";

import styles from "./Typeahead.css";

const TypeaheadItem = ({ label, onSelect, sublabel }) => (
  <div className={styles.item} onClick={onSelect}>
    {sublabel ? (
      <div>
        <div className={styles.left}>{label}</div>
        <div className={styles.right}>{sublabel}</div>
      </div>
    ) : (
      <div>{label}</div>
    )}
  </div>
);

TypeaheadItem.propTypes = {
  label: PropTypes.string.isRequired,
  sublabel: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

export default TypeaheadItem;
